import { SharedConstants } from "../../../../shared/constants/shared.constants";
export const DOCUMENT_NAME_TEXT = "Name";
export const DOCUMENT_CATEGORY_TEXT = "Category";
export const DOCUMENT_DESCRIPTION_TEXT = "Description";
export const DOCUMENT_REQUIRED_TEXT = "Is the document required?";
export const DOCUMENT_UPLOAD_TEXT = "Upload attachment";
export const REMOVE_DIALOG_TEXT = `${SharedConstants.REMOVE_TITLE} afla portal document`;
export const NAME_FORM_CONTROL = "name";
export const DESCRIPTION_FORM_CONTROL = "description";
export const CATEGORY_FORM_CONTROL = "category";
export const REQUIRED_FORM_CONTROL = "required";
export const OPTIONAL_UPLOAD_FORM_CONTROL = "optionalUpload";
export const OPTIONAL_UPLOAD_TEXT = "Can upload as optional document?";
export const OBJECT_NAME = "Afla portal document";
export const VALIDATION_ERR_MSG = SharedConstants.FORM_NOT_VALID;
export const validationMessage = {
    "name": {
        "required": `${DOCUMENT_NAME_TEXT} ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        "maxlength": `${DOCUMENT_NAME_TEXT} ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    "description": {
        "required": `${DOCUMENT_DESCRIPTION_TEXT} ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        "maxlength": `${DOCUMENT_DESCRIPTION_TEXT} ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    "category": {
        "required": `${DOCUMENT_CATEGORY_TEXT} ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        "maxlength": `${DOCUMENT_CATEGORY_TEXT} ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    "required": {
        "required": "Required is not selected",
    }
};
export const formError = {
    "name": "",
    "description": "",
    "category": "",
    "required": ""
};
